import React from 'react'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import PlanningStatusBadge from 'app/KinerjaPenilikPegawaiPage/components/PlanningStatusBadge'

import type { StatusPerencanaan } from 'types/kinerja-penilik-pegawai'

type CardPerencanaanProps = {
  status: StatusPerencanaan
  isPelaksanaanState: boolean
}
const CardPerencanaan = ({
  status,
  isPelaksanaanState,
}: CardPerencanaanProps) => {
  const buttonLabel = React.useMemo(() => {
    let label = 'Cek'

    if (['DIARAHKAN_REVISI_TK', 'DIARAHKAN_REVISI_PPK'].includes(status)) {
      label = 'Lakukan revisi'
    }

    return label
  }, [status])

  return (
    <SimpleCard className="flex flex-row items-center justify-between px-4 py-6 h-fit grow">
      <div
        data-testid="perencanaan-entry-point"
        className="flex flex-col gap-2"
      >
        <Text variant="heading-md" className="mb-2">
          Perencanaan
        </Text>

        {/** Show only on "Perencanaan" states */}
        <PlanningStatusBadge separateRevisionStates state={status} />
      </div>

      <div className="flex space-x-2">
        <Link
          href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/perencanaan${
            isPelaksanaanState ? '/rangkuman' : '/beranda'
          }`}
          passHref
        >
          <Button as="a" size="lg" color="white" className="ml-auto">
            {buttonLabel}
          </Button>
        </Link>
        {status === 'SIAP_DIAJUKAN' && (
          <Link
            href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/perencanaan/ajukan`}
            passHref
          >
            <Button as="a" size="lg" color="blue" className="ml-auto">
              Ajukan Perencanaan
            </Button>
          </Link>
        )}
      </div>
    </SimpleCard>
  )
}

export default CardPerencanaan
